import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatStateService } from '../../services';
import { ConversationListComponent } from '../conversation-list/conversation-list';
import { MessageListComponent } from '../message-list/message-list';
import { MessageInputComponent } from '../message-input/message-input';
import { UserPickerComponent } from '../user-picker/user-picker';

@Component({
  selector: 'app-chat-window',
  standalone: true,
  imports: [
    CommonModule,
    ConversationListComponent,
    MessageListComponent,
    MessageInputComponent,
    UserPickerComponent,
  ],
  templateUrl: './chat-window.html',
  styleUrls: ['./chat-window.scss'],
})
export class ChatWindowComponent {
  readonly state = inject(ChatStateService);

  /** Whether the user-picker compose view is open. */
  composing = signal(false);

  onThreadSelected(threadId: string): void {
    this.state.selectThread(threadId);
  }

  onMessageSent(content: string): void {
    this.state.sendMessage(content);
  }

  onTyping(): void {
    this.state.sendTyping();
  }

  backToList(): void {
    this.state.activeThreadId.set(null);
  }

  openCompose(): void {
    this.composing.set(true);
  }

  cancelCompose(): void {
    this.composing.set(false);
  }

  onParticipantsConfirmed(event: { userIds: string[]; topic: string }): void {
    this.composing.set(false);
    this.state.createThread(event.userIds, event.topic);
  }

  get headerTitle(): string {
    const thread = this.state.activeThread();
    if (!thread) return 'Instant Messages';
    const others = thread.participants
      .filter((p) => p.userId !== this.state.currentUser()?.id)
      .map((p) => p.displayName);
    return others.length ? others.join(', ') : thread.topic || 'Chat';
  }

  get activeThreadInitials(): string {
    const thread = this.state.activeThread();
    if (!thread) return '';
    const other = thread.participants.find((p) => p.userId !== this.state.currentUser()?.id);
    if (!other) return '?';
    const parts = other.displayName.trim().split(/\s+/);
    const first = parts[0]?.[0] ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase();
  }
}
